import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClipboard = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M7.75 3.278h-1.5a2 2 0 0 0-2 2V18.75a2 2 0 0 0 2 2h11.5a2 2 0 0 0 2-2V5.278a2 2 0 0 0-2-2h-1.5m-8.5 0H12m-4.25 0v.972m0-.972V2.25M12 3.278h4.25m-4.25 0v.972m0-.972V2.25m4.25 1.028v.972m0-.972V2.25"
	})
});
export default SvgClipboard;
